import { Box, Progress, Text } from "@chakra-ui/react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { quizListLoadingSuccess, setTopicAndQuiz, topicStartReset } from "../../redux/actions/action";
import TopicDetails from "./TopicDetails";
const extensions = ['mp4', 'm1v', 'ogg', 'mov', 'qt', 'webm', 'm4v', 'wmv', 'avi']

export default function TopicsList({ topics, courseId, completed, total, setContentLink }) {
    const [visibleTopics, setVisibleTopics] = useState([])
    const { quizListData } = useSelector(state => state.quizListState)
    const selectedCourse = useSelector(state => state.selectedCourse.selectedCourse)

    const dispatch = useDispatch()

    useEffect(() => {
        if (topics) {
            setVisibleTopics(topics.filter(topic => topic.status.toUpperCase() === 'Y'))
        }
    }, [topics])

    useEffect(() => {
        if (visibleTopics.length) {
            console.log(visibleTopics)
            if (visibleTopics.every(topic => topic.topic_completed_status === "C")) {
                dispatch(quizListLoadingSuccess(selectedCourse.quiz))
            }
        }
        // eslint-disable-next-line
    }, [visibleTopics])

    const startTopicHandler = (id, content_url, status) => {
        console.log(content_url)
        let contentLink = content_url.replaceAll(" ", "%20")
        setContentLink(contentLink)
        // onOpen()
        let quiz = quizListData.find(quiz => quiz.topic_id && status === 'I' && quiz.topic_id.toString() === id.toString())
        dispatch(setTopicAndQuiz(id, status === "P" && quiz ? quiz.id : null))
        dispatch(topicStartReset())
    }

    const getFileType = (contentLink) => {
        return extensions.includes(contentLink.substring(contentLink.lastIndexOf('.') + 1))
    }


    return (
        <Box
            width={['100%', '100%', '100%', '100%', '47.5%']}
            bg='#ffffff'
            height={['250px', '300px', '350px', '350px', '95%']}
            borderRadius='10px'
            // overflowY='auto'
            py='1rem'
            boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
        >
            <Box
                d='flex'
                justifyContent='space-between'
                alignItems='center'
                mb='2'
                px='1.5rem'
            >
                <Text
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    fontSize={['18px', '18px', '22px', '24px', '26px']}
                    fontWeight='900'
                    color='#000000'
                >
                    Topics
                </Text>
                <Text
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    fontSize={['8px', '8px', '8px', '12px', '12px']}
                    fontWeight='700'
                    color='#568f33'
                    textTransform='uppercase'
                >
                    {completed}/{total} Completed
                </Text>
            </Box>
            <Box
                mb='2'
                px='1.5rem'
            >
                <Progress size='xs' value={(completed / total) * 100} colorScheme='red' width='100%' borderRadius='md' />
            </Box>
            <Box
                width='100%'
                overflowY='auto'
                d='flex'
                flexDir='column'
                height={['75%', '80%', '80%', '80%', '85%']}
                sx={{
                    '&::-webkit-scrollbar': {
                        width: '10px',
                        borderRadius: '8px',
                        backgroundColor: `transparent`,
                        height: '90%',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: `rgba(255, 255, 255,0.2)`,
                        borderRadius: '20px'
                    },
                }}
            >
                {
                    visibleTopics?.length > 0 ?
                        visibleTopics.map(topic => <TopicDetails
                            key={topic.id}
                            topic_id={topic.id}
                            image={topic.cover_image}
                            title={topic.title}
                            quizzes={topic.quiz_count}
                            method={startTopicHandler}
                            status={topic.topic_completed_status}
                            content_url={topic.content_url}
                            courseId={courseId}
                            fileType = {getFileType(topic.content_url)}
                        />) :
                        <Text
                            fontWeight='500'
                            fontSize={['10px', '14px', '16px', '16px']}
                            color='#333333'
                            textAlign='center'
                            mt='2'
                        >
                            No topics to display!
                        </Text>
                }
            </Box>
        </Box>
    )
}